import {
  collection,
  doc,
  addDoc,
  updateDoc,
  deleteDoc,
  getDocs,
  getDoc,
  query,
  orderBy,
  serverTimestamp,
} from "firebase/firestore";
import { db } from "../firebase";

export async function createClient(userId, clientData) {
  const clientsRef = collection(db, "users", userId, "clients");
  const docRef = await addDoc(clientsRef, {
    ...clientData,
    createdAt: serverTimestamp(),
  });
  return docRef.id;
}

export async function updateClient(userId, clientId, updates) {
  const ref = doc(db, "users", userId, "clients", clientId);
  await updateDoc(ref, updates);
}

export async function deleteClient(userId, clientId) {
  await deleteDoc(doc(db, "users", userId, "clients", clientId));
}

export async function getClients(userId) {
  const q = query(collection(db, "users", userId, "clients"), orderBy("createdAt", "desc"));
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
}

export async function getClient(userId, clientId) {
  const snap = await getDoc(doc(db, "users", userId, "clients", clientId));
  return snap.exists() ? { id: snap.id, ...snap.data() } : null;
}